<template>
  <div>
    <!-- type不为2的情况 -->
    <div class="game-home" v-if="obj.type != 2">
      <dl class="company" v-for="(item, index) in list" :key="index">
        <dt class="header">
          <!-- <img
            src="https://img.doremibar.com/uploads/image/20200822/40a4ecec43ece408.png"
            alt=""
            height="20"
            class="logo"
          /> -->
          <i>{{ item.name }}</i> 全部游戏
          <!-- <router-link :to="'/menueWarp/second/' + item.id"
            >全部游戏</router-link> -->
        </dt>
        <dd class="list">
          <ul>
            <!-- v-show="childIndex >= (currentPage -1)*pageSize && childIndex < currentPage*pageSize" -->
            <li
              class="item"
              v-for="(child, childIndex) in item.children"
              :key="childIndex"
            >
              <div class="wrap">
                <img
                  :src="$config.imgHost + child.pictureUrl"
                  :onerror="errorImage"
                  alt=""
                  height="140"
                  class="pic"
                />
                <span class="name">{{ child.name }}</span>
                <div class="mask">
                  <button class="btn" @click="getToken(child)">开始游戏</button>
                </div>
              </div>
            </li>
            <p
              v-if="item.children.length == 0"
              style="
                text-align: center;
                width: 100%;
                font: 24px/36px bold;
                color: #ccc;
                margin-top: 200px;
              "
            >
              暂无游戏
            </p>
          </ul>
        </dd>
        <div class="bar"></div>
      </dl>
      <div
        class="pagi"
        style="text-align: center; margin-bottom: 30px"
        v-show="showBtmPagi"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="listSize"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- type为2的情况 -->
    <div class="game-home" v-if="obj.type == 2">
      <dl class="company">
        <dd class="list">
          <ul>
            <li
              class="item"
              v-for="(item, index) in list"
              :key="index"
              v-show="
                index >= (currentPage - 1) * pageSize &&
                index < currentPage * pageSize
              "
            >
              <div class="wrap">
                <img
                  :src="$config.imgHost + item.imgUrl"
                  :onerror="errorImage"
                  alt=""
                  height="140"
                  class="pic"
                />
                <span class="name">{{ item.name }}</span>
                <div class="mask">
                  <button class="btn" @click="getToken(item, 2)">
                    开始游戏
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </dd>
        <div class="bar"></div>
      </dl>
      <div class="pagi" style="text-align: center; margin-bottom: 30px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="listSize"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="curList.length"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api"; //接口名字
export default {
  name: "component_name",
  data() {
    return {
      curList: {}, //当前列表
      list: [], //电子游艺 棋牌游戏 type!=2 调接口 二级菜单
      obj: {}, //一级菜单对象
      listIndex: 0, //当前选中列表中的哪一项
      showPagi: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      listSize: [10, 20, 30, 50],
      proId: "", //idn监听获取
      errorImage: "", //'this.src="' + require('../../assets/images/errorpic.png') + '"'
    };
  },
  computed: {
    showBtmPagi() {
      //console.log('我是小猪，我改变啦1',this.curList.children);
      // if(this.curList.children){
      //   if(this.curList.children.length > 0){
      //     return true
      //   }else{
      //     return false
      //   }
      // }else{
      //   return false
      // }
      return this.curList.children && this.curList.children.length > 0;
    },
  },
  mounted() {
    // 首次进入在顶部
    document.documentElement.scrollTop = 0;
  },
  methods: {
    getToken: async function (req, index) {
      // console.log('检测游戏信息',req)
      // return
      let self = this;
      var issafariBrowser =
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent);
      if (!self.$common.getUser()) {
        // self.showLogin = true;
        self.$message.warning("请登录");
        return;
      }
      self.tenantId = self.$common.getUser().tenant_id;
      self.username = self.$common.getUser().username;
      self.uid = self.$common.getUser().user_id;
      let datas = {
        tenantId: self.tenantId,
        username: self.username,
        gameId: index == 2 ? req.ids : req.id,
        clientIp: self.$config.clientIp,
        memberId: self.uid,
        terminalType: 1,
      };
      self.$common.setGameRequestData(datas);

      const res = await self.$http.post(api.getToken, datas, true);
      if (res.code == 0) {
        self.gameUrl = res.data;
        if (req.openMode === 1) {
          // if(issafariBrowser) {
          //  self.winOpen.location.href = self.gameUrl;
          // }else{
          window.open(self.gameUrl);
          // }
        } else {
          window.open(self.gameUrl);
        }
      } else {
        if (req.openMode === 1) {
          window.open("/error.html?type=1");
          // self.winOpen.location.href = '/error.html?type=1';
        }

        if (req.status === 0) {
          self.$message.error("维护中");
        } else {
          self.$message.error("进入游戏失败，请稍后重试！");
        }
      }
    },

    // 更改当前页展示数量
    handleSizeChange(val) {
      //console.log('条数改变之前',this.pageSize);
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.addList(this.proId);
      //console.log('条数改变之后',this.pageSize)
    },
    // 更改当前页
    handleCurrentChange(val) {
      //console.log('改变之前',this.currentPage)
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.addList(this.proId);
      //console.log('改变之后',this.currentPage)
    },

    // watch提取数据
    addList(newVal) {
      console.log("新的index", newVal);
      var self = this;
      var arr = JSON.parse(localStorage.getItem("ALLMENUE_EXCEPT_FISH"));
      var obj = {}; //first对象
      var list = []; //first children
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id == newVal) {
          obj = arr[i];
          list = arr[i].children;
          break;
        }
      }
      console.log("一级数据列表", obj);
      // this.currentPage = 1;
      if (obj.type == 2) {
        this.list = list;
        this.obj = obj;
        this.curList = list;
      } else {
        var promiseList = [];
        list.forEach((item, index) => {
          // //console.log(index,this.listIndex)
          // 顶部跳转 捕鱼id：406
          if (
            (item.type == 1 && this.listIndex == index) ||
            (newVal == -1 && item.type == 1 && item.id == "406")
          ) {
            // //console.log(index)
            promiseList.push(
              new Promise((resolve, reject) => {
                self.$http.pnPost(
                  self.$api.vendorGame,
                  {
                    currentPage: self.currentPage,
                    pageSize: self.pageSize,
                    gameKindId: newVal,
                    vendorId: item.ids,
                  },
                  true,
                  (res) => {
                    console.log("结果", res);
                    self.total = res.data.data.total;
                    (item.children = res.data.data.list), item;
                    //console.log('打印出的数据',item)
                    resolve(item);
                  }
                );
              })
            );
            // 顶部跳转 捕鱼id：406
          } else if (item.type == 3 && this.listIndex == index) {
            promiseList.push(
              new Promise((resolve, reject) => {
                self.$http.pnPost(
                  self.$api.getGameByIds,
                  {
                    currentPage: self.currentPage,
                    pageSize: self.pageSize,
                    gameKindId: newVal,
                    ids: item.ids,
                  },
                  true,
                  (res) => {
                    console.log("结果", res);
                    self.total = res.data.data.total;
                    (item.children = res.data.data.list), item;
                    resolve(item);
                  }
                );
              })
            );
          } else if (
            this.listIndex == -1 &&
            item.type == 1 &&
            item.id == "406"
          ) {
            promiseList.push(
              new Promise((resolve, reject) => {
                self.$http.pnPost(
                  self.$api.vendorGame,
                  {
                    currentPage: self.currentPage,
                    pageSize: self.pageSize,
                    gameKindId: newVal,
                    vendorId: item.ids,
                  },
                  true,
                  (res) => {
                    console.log("结果", res);
                    self.total = res.data.data.total;
                    (item.children = res.data.data.list), item;
                    //console.log('打印出的数据',item)
                    resolve(item);
                  }
                );
              })
            );
          } else if (
            this.listIndex == -1 &&
            item.type == 3 &&
            item.id == "406"
          ) {
            promiseList.push(
              new Promise((resolve, reject) => {
                self.$http.pnPost(
                  self.$api.getGameByIds,
                  {
                    currentPage: self.currentPage,
                    pageSize: self.pageSize,
                    gameKindId: newVal,
                    ids: item.ids,
                  },
                  true,
                  (res) => {
                    console.log("结果", res);
                    self.total = res.data.data.total;
                    (item.children = res.data.data.list), item;
                    resolve(item);
                  }
                );
              })
            );
          }
        });
        Promise.all(promiseList).then((result) => {
          this.list = result;
          this.obj.type = 1;
          //console.log('list列表',this.list)
          this.curList = this.list[0];
        });
      }
    },
  },
  watch: {
    // 路由切换选项监听
    // "$route.params.index": {
    //   handler(newval) {
    //     console.log("新的索引", newval);

    //     this.listIndex = newval ? newval : 0;

    //     // ------更改时会关系到展示问题-------
    //     setTimeout(() => {
    //       this.addList(this.proId);
    //       console.log('当前列表',this.curList);
    //     }, 0);
    //     this.currentPage = 1;
    //   },
    //   immediate: true,
    // },
    "$route.params.idn": {
      handler(newVal) {
        this.proId = newVal;
        this.addList(newVal);
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.game-home .company {
  background: #fff;
}
.game-home .company .header {
  background: #fff;
  height: 38px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
}
.game-home .company .header i {
  margin: 0 10px;
  color: red;
  font-weight: 600;
}
.game-home .company .header .logo {
  display: inline-block;
  margin: 0 20px;
}
.game-home .company .header .all {
  color: #666;
  font-size: 16px;
  cursor: pointer;
}
.game-home .company .list {
  padding-bottom: 20px;
}
.game-home .company .list > ul {
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.wrap {
  margin-top: 20px;
  margin-left: 20px;
  border: 2px solid transparent;
  text-align: center;
  position: relative;
  background: #f4f4f4;
  border-radius: 4px;
  min-width: 160px;
}
.wrap .pic {
  display: block;
  margin: 10px;
  width: 140px;
}
.wrap .name {
  border-top: 1px solid #fff;
  display: inline-block;
  width: 100%;
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  color: #f43b5b;
  background-color: #f4f4f4;
}
.wrap .mask {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
}
.wrap .mask:hover {
  opacity: 1;
}
.wrap .mask .btn {
  position: absolute;
  background: #f43b5b;
  width: 100px;
  height: 40px;
  font-size: 16px;
  color: #fff;
  border: 0;
  outline: none;
  line-height: 40px;
  top: 50%;
  left: 50%;
  margin-top: -20px;
  margin-left: -50px;
  cursor: pointer;
  border-radius: 2px;
}

.type2 {
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 20%;
      margin: 10px;
    }
  }
}
</style>
